import { ChangeEvent, useEffect, useState } from 'react';
import { classNames } from '../../helpers/classNames';
import NavDataInterface from '../../interfaces/NavDataInterface';
import Input from '../Input';
import SideNavItem from './SideNavItem';
import styles from './style.module.scss';

interface Props {
    navData: NavDataInterface[];
    children?: any;
    className?: any;
    extendable?: boolean;
    isSticky?: boolean;
    selected: string;
    hasSearchBar?: boolean;
    searchBarLabel?: string;
    searchBarPlaceholder?: string;
    handleSearchChange?: (event: ChangeEvent<HTMLInputElement>) => void;
}

function SideNav(props: Props) {
    const {
        navData,
        children = '',
        className,
        extendable = false,
        selected,
        isSticky,
        hasSearchBar = false,
        searchBarLabel = '',
        searchBarPlaceholder = '',
        handleSearchChange,
    } = props;

    const [data, setData] = useState<NavDataInterface[]>([]);

    useEffect(() => {
        setData(navData);
    }, [navData, extendable]);

    const handleSearchCase = (event: ChangeEvent<HTMLInputElement>) => {
        const { value = '' } = event.target;
        const searchedCase = navData.filter((x: NavDataInterface) => {
            return (
                x.label
                    .toLocaleLowerCase()
                    .includes(value.toLocaleLowerCase()) ||
                x.subLabel
                    ?.toLocaleLowerCase()
                    .includes(value.toLocaleLowerCase())
            );
        });
        setData(searchedCase);
        if (handleSearchChange) {
            handleSearchChange(event);
        }
    };

    return (
        <div className={classNames([styles.sideNav, className])}>
            <div className={classNames([isSticky ? styles.sticky : ''])}>
                <div className={styles.navHeader}>
                    {hasSearchBar && (
                        <div className={styles.navSearchBar}>
                            <Input
                                label={searchBarLabel}
                                onChange={handleSearchCase}
                                placeholder={searchBarPlaceholder}
                            />
                        </div>
                    )}
                    {children}
                </div>
                <div className={styles.linksContainer}>
                    {data?.map((item) => (
                        <SideNavItem
                            key={item.id}
                            item={item}
                            selected={selected}
                            onClick={item.onClick}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}

export default SideNav;
